import useWidget from '../../../hooks/useWidget.js';
import useWidgetState from '../../../hooks/useWidgetState.js';
import { findFacetValueOnResponseByValueId, getFacetConfigType } from '../utils/index.js';
const ValueIdFacetChecker = {
    isSelectedFacet: (selectedFacets, facetType, facetValueId) => selectedFacets.some((f) => 'facetValueId' in f && f.facetId === facetType && f.facetValueId === facetValueId),
};
const TextFacetChecker = {
    isSelectedFacet: (selectedFacets, facetType, facetValueId, response) => {
        const item = findFacetValueOnResponseByValueId(response, facetType, facetValueId);
        if (!item || !item.text) {
            return false;
        }
        // @TODO: see if we can improve this, asking for faceValueText looks weird.
        return selectedFacets.some((f) => 'facetValueText' in f && f.facetId === facetType && f.facetValueText === item.text);
    },
};
const RangeFacetChecker = {
    isSelectedFacet: () => false,
};
const selectedFacetChecker = {
    valueId: ValueIdFacetChecker,
    text: TextFacetChecker,
    range: RangeFacetChecker,
};
const useSearchResultsIsSelectedFacet = (facetType, facetValueId) => {
    const { config, state: { response } = {} } = useWidget();
    const type = getFacetConfigType(config, facetType);
    const { selectedFacets = [] } = useWidgetState();
    const facetChecker = selectedFacetChecker[type] ? selectedFacetChecker[type] : undefined;
    return (typeof facetChecker !== 'undefined' &&
        facetChecker.isSelectedFacet(selectedFacets, facetType, facetValueId, response));
};
export default useSearchResultsIsSelectedFacet;
